import React, { useState } from "react";
import { Button, Form, InputGroup, Alert, Spinner } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useLogin } from "../../../hooks/useLogin";
import "./authForms.scss";

const RegistrationForm = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [alert, setAlert] = useState(null);
  const [pwdVisible, setPwdVisible] = useState(false);
  const [passwordStrength, setPasswordStrength] = useState("");
  const [passwordSuggestions, setPasswordSuggestions] = useState([]);
  const [country, setCountry] = useState("");
  const togglePwd = () => setPwdVisible(!pwdVisible);

  const { signup, isLoading } = useLogin();
  const navigate = useNavigate();

  const handleRegister = async (e) => {
    e.preventDefault();

    if (username === "" || password === "" || email === "") {
      setAlert({
        variant: "danger",
        message: "Please complete the form before registration.",
      });
      return;
    } else if (passwordStrength !== "strong") {
      setAlert({
        variant: "danger",
        message: "Please choose a stronger password.",
      });
      return;
    }

    const response = await signup(username, email, password);
    const errMessage =
      response.response?.data?.message ||
      "An error occurred. Please try again.";

    if (response === "success") {
      setAlert({
        variant: "success",
        message:
          "Registration successful! Please verify your email with the code sent to you.",
      });

      // Navigate to the verification page
      setTimeout(() => {
        navigate("/verify", { state: { email: email } });
      }, 2000);
    } else {
      setAlert({
        variant: "danger",
        message: errMessage,
      });
    }
  };

  const checkPasswordStrength = (pwd) => {
    let strength = "strong";
    let suggestions = [];

    if (pwd.length < 8) {
      strength = "weak";
      suggestions.push("Password should be at least 8 characters long.");
    }
    if (!/[A-Z]/.test(pwd)) {
      strength = "weak";
      suggestions.push("Add at least one uppercase letter.");
    }
    if (!/\d/.test(pwd)) {
      strength = "medium";
      suggestions.push("Include at least one number.");
    }
    if (!/[!@#$%^&*]/.test(pwd)) {
      strength = "weak";
      suggestions.push("Use at least one special character (@, #, $,!,...).");
    }

    setPasswordStrength(strength);
    setPasswordSuggestions(suggestions);
  };

  const handlePasswordChange = (e) => {
    const pwd = e.target.value;
    setPassword(pwd);
    checkPasswordStrength(pwd);
  };
  return (
    <>
      <div className="login-container">
        <div className="login-div">
          {alert && (
            <Alert
              variant={alert.variant}
              onClose={() => setAlert(null)}
              dismissible
            >
              {alert.message}
            </Alert>
          )}

          <p className="form-desc">Please Use Form Below to Register.</p>
          <Form className="form-box">
            <Form.Group className="mb-3 box-form" controlId="formBasicUsername">
              <Form.Label className="text-above-box">Enter Username</Form.Label>
              <Form.Control
                type="text"
                autoComplete="off"
                onChange={(e) => {
                  setUsername(e.target.value);
                }}
              />
            </Form.Group>
            <Form.Group className="mb-3 box-form" controlId="formBasicEmail">
              <Form.Label className="text-above-box">Enter email</Form.Label>
              <Form.Control
                type="email"
                autoComplete="off"
                onChange={(e) => {
                  setEmail(e.target.value);
                }}
              />
            </Form.Group>
            <Form.Group className="mb-3 box-form" controlId="formBasicPassword">
              <Form.Label className="text-above-box">Enter Password</Form.Label>
              <InputGroup bsPrefix="inputPassword">
                <Form.Control
                  type={pwdVisible ? "text" : "password"}
                  onChange={handlePasswordChange}
                />
                <Button className="togglePassword">
                  {" "}
                  {!pwdVisible ? (
                    <FaEyeSlash onClick={togglePwd} />
                  ) : (
                    <FaEye onClick={togglePwd} />
                  )}{" "}
                </Button>
              </InputGroup>

              {passwordStrength.length > 0 && (
                <p className={`password-strength ${passwordStrength}`}>
                  {" "}
                  Password strength: {passwordStrength}
                </p>
              )}

              {passwordSuggestions.length > 0 && (
                <ul className="password-suggestions">
                  {passwordSuggestions.map((suggestion, index) => (
                    <li key={index}>{suggestion}</li>
                  ))}
                </ul>
              )}
            </Form.Group>
            {isLoading ? (
              <Spinner animation="border" variant="primary" />
            ) : (
              <>
                <div className="d-grid gap-2">
                  <Button
                    variant="btn btn-primary login-buttomn"
                    type="submit"
                    onClick={handleRegister}
                  >
                    Register
                  </Button>
                </div>

                <h6 className="form-register-link">
                  You already have an account? Please{" "}
                  <Link to="/" className="link-to">
                    login
                  </Link>
                  .
                </h6>
              </>
            )}
          </Form>
        </div>
      </div>
    </>
  );
};

export default RegistrationForm;
